import React from 'react';
import styles from '../CartItemsTable.scss';
import { Popover, PopoverContent } from '../../../Common/reactstrap/lib';
export default class TableItemQuantity extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false
    };
  }
  componentWillReceiveProps(nextProps){

  }
  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }
  onChange (q, oDI, e) {
    if (q < 1) {
      return false;
    }
    if(this.props.limit < q){
      this.setState({
        popoverOpen: true
      });
      q = this.props.limit;
    }
      this.props.onChange(q, oDI);
  }

  onInputChange = (e) => {
    e.preventDefault();
    this.onChange(+e.target.value, this.props.cartDetailId);
  };

  render() {
    let {quantity, cartDetailId, partion} = this.props,
      popTarget = `target-${cartDetailId}`;
      partion = partion == 0 ? 1 : partion;
    quantity = quantity == 0 ? partion : quantity;
    return (
      <div className={styles.itemQuantityBlock}>
        <Popover  placement="top" isOpen={this.state.popoverOpen} target={popTarget} toggle={this.toggle}>

          <PopoverContent>
            <button type="button" onClick={this.toggle} className="close" aria-label="Close">
              <span aria-hidden="true">{String.fromCharCode(215)}</span>
            </button>
            <div className="mr-4 px-1">Доступно для заказа </div>
            <div className=" px-1">только {quantity} шт</div>
          </PopoverContent>
        </Popover>
        <button
          className={styles.minusBtn}
          onClick={this.onChange.bind(this, quantity - partion, cartDetailId)}>
          <div />
        </button>
        <input
          id={popTarget}
          type="number"
          onChange={this.onInputChange}
          className={styles.itemQuantityIndicator}
          value={quantity}
          />
        <button
          className={styles.plusBtn}
          onClick={this.onChange.bind(this, quantity + partion, cartDetailId)}>
          <div />
          <div />
        </button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Cart/elements/tableElements/TableItemQuantity.jsx
 **/